import React, { useMemo } from 'react';
import { Modal } from 'antd';
import styles from './ContractorInfoModal.module.scss';
import classNames from 'classnames';
import moment from 'moment';

const getFullName = (obj) => {
  return `${obj.surName ? `${obj.surName} ` : ''}${
    obj.firstName ? `${obj.firstName} ` : ''
  }${obj.patrName ? `${obj.patrName} ` : ''}`;
};

const ContractorInfoModal = ({
  visible,
  onCancel,
  isPerson = true,
  counterparty,
}) => {
  const actualAddress = counterparty.actualAddress?.fullAddress;
  const registrationAddress = counterparty.registrationAddress?.fullAddress;
  const fullCity = counterparty.individualInfo?.cityBirth?.fullCity;

  const getInfoBlock = (header, info = '-', isHighlighted = false) => (
    <div className={styles.infoBlock}>
      <div className={styles.header}>{header}</div>
      <div className={isHighlighted ? styles.highlight : ''}>{info}</div>
    </div>
  );

  const address = useMemo(() => {
    if (!isPerson) {
      if (actualAddress) {
        if (actualAddress === registrationAddress) {
          return 'Совпадает с юридическим адресом';
        }

        return actualAddress;
      }

      return '-';
    }

    return fullCity || '-';
  }, [isPerson, actualAddress, registrationAddress, fullCity]);

  return (
    <Modal
      title={`Полная информация • ${
        counterparty.name || getFullName(counterparty)
      }`}
      visible={visible}
      onCancel={onCancel}
      width={650}
      footer={null}
    >
      <div className={styles.infoLayout}>
        <div className={styles.wideColumn}>
          {getInfoBlock(
            'Телефон',
            counterparty.phoneNumber,
            Boolean(counterparty.phoneNumber)
          )}
          {getInfoBlock(
            'Почта',
            counterparty.email,
            Boolean(counterparty.email)
          )}
          <div className={styles.infoBlock}>
            <div className={styles.header}>
              {isPerson ? 'Адрес регистрации' : 'Юридический адрес'}
            </div>
            <div>{counterparty.registrationAddress?.fullAddress || '-'}</div>
          </div>

          <div className={styles.infoBlock}>
            <div className={styles.header}>
              {isPerson ? 'Место рождения' : 'Фактический адрес'}
            </div>
            <div>{address}</div>
          </div>
        </div>
        {isPerson ? (
          <>
            <div className={styles.smallColumn}>
              {getInfoBlock('Страна', counterparty.country?.name)}
              {getInfoBlock(
                'Подразделение',
                counterparty.individualInfo?.passportSubDivision
              )}
              {getInfoBlock('Тип', counterparty.type.shortName)}
              {getInfoBlock(
                'Дата выдачи',
                counterparty.individualInfo?.passportDate &&
                  moment(counterparty.individualInfo?.passportDate).format(
                    'DD.MM.YYYY'
                  )
              )}
            </div>
            <div className={styles.smallColumn}>
              {getInfoBlock(
                'Серия и номер ',
                `${counterparty.individualInfo?.passportSeries || '-'} ${
                  counterparty.individualInfo?.passportNumber || '-'
                }`
              )}
              {getInfoBlock(
                'Кем выдан',
                counterparty.individualInfo?.passportIssued
              )}
              {getInfoBlock(
                'Дата рождения',
                counterparty.individualInfo?.dateBirth &&
                  moment(counterparty.individualInfo?.dateBirth).format(
                    'DD.MM.YYYY'
                  )
              )}
            </div>
          </>
        ) : (
          <>
            <div className={styles.wideColumn}>
              {getInfoBlock(
                'ИНН/ ОГРН',
                `${
                  counterparty.legalEntityInfo?.inn
                    ? counterparty.legalEntityInfo?.inn
                    : '-'
                }/${
                  counterparty.legalEntityInfo?.ogrn
                    ? counterparty.legalEntityInfo?.ogrn
                    : '-'
                }`
              )}
              <div className={classNames(styles.wideColumn, styles.horizontal)}>
                <div className={styles.wideColumn}>
                  {getInfoBlock('Страна', counterparty.country?.name)}
                  {getInfoBlock('Тип', counterparty.type?.name)}
                </div>
                <div className={styles.wideColumn}>
                  {getInfoBlock('КПП', counterparty.legalEntityInfo?.kpp)}
                  {getInfoBlock('ОКПО', counterparty.legalEntityInfo?.okp)}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default ContractorInfoModal;
